module.exports = __webpack_public_path__ + "img/num4.f252e8e6.svg";